<div class="container">
  <div class="left">
    <div
      *ngIf="showroom.logoUrl && showroom.branded"
      class="showroom-logo"
    >
      <img
        [src]="showroom.logoUrl"
        imgErrLog
      />
    </div>
    <button
      class="blank-button powered-by"
      merriNoFocusLink
      *ngIf="showroom.branded"
      (click)="onPoweredByClick()"
    >
      <div class="copy-container">
        <span class="copy">Powered by</span>
        <img
          [src]="logoPoweredByUrl"
          imgErrLog
          class="image-powered-by"
        />
      </div>
      <mat-icon svgIcon="help"></mat-icon>
    </button>
  </div>

  <div class="right">
    <div
      class="view-another-room-container"
      *ngIf="showBackToWelcomeButton"
    >
      <button
        class="blank-button button-view-another-room"
        (click)="onViewAnotherRoomClick()"
        merriNoFocusLink
      >
        <mat-icon svgIcon="meeting_room"></mat-icon>
        Explore Another Room
      </button>
    </div>
    <app-showroom-shortlist-trigger *ngIf="showShortlist"></app-showroom-shortlist-trigger>
    <button
      mat-flat-button
      color="primary"
      class="merri-common-button-bold"
      (click)="onInquireNowClick()"
    >
      Inquire
    </button>
  </div>
</div>
